<template>
  <div class="strengths-list-pair">
    <div class="col-md-4 col-xs-12">
      <div class="strengths-list-title-box">Solo</div>

      <ol class="strengthList strengths-list-inner text-center">
        <li v-for="(rating, index) in soloRatings" v-bind:key="rating.strength.name">
          <a
            @click="click(rating.strength.name)"
            href="javascript:void(0)"
            class="a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor"
            :class="[
              fontClass(index),
              activeStrength === rating.strength.name ? 'active' : activeStrength ? 'inactive' : '',
            ]"
          >
            <div class="cs-accordion-anchor-child">
              {{ rating.strength.name }}
            </div>
          </a>
        </li>
      </ol>
    </div>

    <div class="col-md-4 col-xs-12">
      <div class="strengths-list-title-box">Viewpoints</div>

      <ol class="strengthList strengths-list-inner text-center">
        <li v-for="(rating, index) in viewpointsRatings" v-bind:key="rating.strength.name">
          <a
            @click="click(rating.strength.name)"
            href="javascript:void(0)"
            class="a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor"
            :class="[
              fontClass(index),
              activeStrength === rating.strength.name ? 'active' : activeStrength ? 'inactive' : '',
            ]"
          >
            <div class="cs-accordion-anchor-child">
              {{ rating.strength.name }}
            </div>
          </a>
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { StrengthItemRatingApiModel } from "../../api-models";
import { DEFAULT_RATINGS, fontClass } from "./strengths-list-helpers";

const props = withDefaults(
  defineProps<{
    soloRatings: StrengthItemRatingApiModel[];
    viewpointsRatings: StrengthItemRatingApiModel[];
  }>(),
  {
    soloRatings: () => DEFAULT_RATINGS,
    viewpointsRatings: () => DEFAULT_RATINGS,
  },
);

const activeStrength = ref("");

function click(name: string): void {
  if (activeStrength.value === name) {
    activeStrength.value = "";
  } else {
    activeStrength.value = name;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.session.session-inline {
  .strengths-list-pair-wrapper {
    margin: 0 auto 50px auto;
    // width: 90vw;
    overflow: hidden;
    transition: width 0.5s;
  }

  .strengths-list-pair-wrapper.strengths-list-pair-wrapper-unclipped {
    width: 560px;
    transition: width 0s;
  }

  .strengths-list-pair-wrapper.strengths-list-pair-wrapper-reclipped {
    width: 90vw;
    transition: width 0.5s;
  }
}

.strengths-list-pair {
  margin: 0 auto;
}

.strengths-list-pair {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  @media screen and (max-width: 570px) {
    flex-direction: column;
  }
}

.strengths-list-pair > * {
  width: 280px;
}

.strengths-list-pair .strengths-list-item-anchor.active {
  color: #aa084e !important;
  font-weight: bold;
  text-decoration: underline;
  line-height: 1.42857143 !important;
}

.strengths-list-pair .strengths-list-item-anchor.inactive {
  color: #999 !important;
}
</style>
